import { Component, OnInit, OnDestroy, Input, ViewChild, NgZone, ChangeDetectorRef } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BulkEditInputComponent } from './bulk-edit-input/bulk-edit-input.component';
import { AgGridEditService } from '../services/ag-grid-edit.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';
import { MessageService } from 'primeng/api';
import { ItemService } from 'src/app/cms-v2/entities/item/services/item.service';
import TableBulkBuild from '../../components/dynamic-table/dtos/TableBulkBuild';
import { BuildType } from 'src/app/enums/build-type';
import { UtilitiesService } from '../../services/utilities.service';
import { DataService } from 'src/app/services/data.service';
import TableBulkPromotion from '../../components/dynamic-table/dtos/TableBulkPromotion';
import { PromotionService } from 'src/app/services/promotion.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/common/services/environment.service';
import { TableCommunicationService } from '../services/table-communication.service';
import { AgGridToolsService } from '../services/ag-grid-tools.service';
import { ItemSetService } from 'src/app/cms-v2/entities/item-set/item-set-service/item-set.service';
import {v4 as uuidv4} from 'uuid';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChallengeService } from 'src/app/entities/challenge/services/challenge.service';
import { AuthService } from 'src/app/auth/auth.service';
import { LoggerService } from 'src/app/common/services/logger.service';


@Component({
  selector: 'app-ag-grid-actions',
  templateUrl: './ag-grid-actions.component.html',
  styleUrls: ['./ag-grid-actions.component.sass'],
  providers: [MessageService],
})
export class AgTableActionsComponent implements OnInit, OnDestroy {
  @ViewChild('bulkEditInput', { static: false }) bulkEditInput: BulkEditInputComponent; // Adjust the type to your actual component class name
  @ViewChild('collectionDropdown') collectionDropdown?: Dropdown;

  constructor(
    private sanitizer: DomSanitizer,
    private agGridEditService: AgGridEditService,
    private spinnerService: SpinnerService,
    private commonEntityService: CommonEntityService,
    private messageService: MessageService,
    private itemService: ItemService,
    private utilitiesService: UtilitiesService,
    private dataService: DataService,
    private promotionService: PromotionService,
    private httpClient: HttpClient,
    private ngZone: NgZone,
    private tableCommunicationService: TableCommunicationService,
    private agGridToolsService: AgGridToolsService,
    private itemSetService: ItemSetService,
    private spinner: NgxSpinnerService,
    private challengeService: ChallengeService,
    public authService: AuthService,
    private loggerService: LoggerService,
    private cdr: ChangeDetectorRef,
  ) {
    this.setEnvironmentName();
    this.setEnvironmentsArray();
  }

  display: boolean = false;

  @Input() bulkUpdateColDefs: any[] = [];
  @Input() gridApi: any;
  @Input() columnApi: any;
  @Input() entity: string;
  @Input() mongoQuery: any;
  @Input() mongoSort: any;
  @Input() rowsSelected: any[];
  @Input() areRowsSelected: boolean;
  @Input() selectedRowsSet: Set<any>;
  @Input() isSelectAll: boolean;
  @Input() totalRecords: number;
  @Input() loadedRowCount: number;
  @Input() changedRows: Map<number, any>;
  @Input() buildParams: any;
  @Input() tableParams: any;
  @Input() userParams: any;
  @Input() populateFields: any;
  @Input() tableInstanceId: string;
  //
  @Input() fetchAllRowsFromBackend: Function;
  //

  environmentName: string;
  bulkEditState: 'select-column' | 'select-edit-type' | 'edit-values' | 'verify-changes' = 'select-column';
  bulkEditStep: number = 0;
  bulkEditSteps = [
    { label: 'Field' },
    { label: 'Edit type' },
    { label: 'Value' },
    { label: 'Preview' },
  ];
  bulkEditDialogVisible = false;
  selectedBulkEditColumns: any[] = [];
  capturedInputOptions: any[] = [];
  editType: any;
  submitInProgress: boolean = false;
  isLoading: boolean = false;
  progress: number = 0;
  rowStatus: Record<string, 'pending' | 'saving' | 'done' | 'error'> = {};

  //  add to collection
  addToCollectionDialogVisible = false;
  createCollectionDialogVisible = false;
  isCreatingCollection = false;
  collections: any[] = [];
  selectedCollection: any;
  createCollection: any = {
    name: '',
    items_ref: []
  }
  //  add to item set
  addToItemSetDialogVisible = false;
  createItemSetDialogVisible = false;
  itemSets: any[] = [];
  selectedItemSet: any;
  createItemSet: any = {
    name: '',
    items_ref: []
  };


  showImportQuestions: boolean = false;
  showImportAnswers: boolean = false;
  showImportCollections: boolean = false;

  // BUILD AND RENDER
  buildAndRender: boolean = false;
  bulkBuild: TableBulkBuild = new TableBulkBuild();
  showBulkBuild: boolean = false;
  showBuildProgress: boolean = false;
  bulkBuildProgress: number = 0;
  disableBuildButton: boolean = false;
  showBulkBuildFailed: boolean = false;
  showDupConfirmDialog: boolean = false;
  dupFailuresForConfirm: any[] = [];
  private _dupConfirmContext: { bulkBuildId: string; newHash: boolean; resolve: () => void } | null = null;

  // BULK PROMOTE
  bulkPromote: TableBulkPromotion = new TableBulkPromotion();
  showBulkPromote: boolean = false;
  showBulkPromoteFailed: boolean = false;
  isAssetPromotion: boolean = false;
  isCombinedPromotion: boolean = false;
  disablePromoteButton: boolean = false;
  showPromoteProgress: boolean = false;
  bulkPromoteProgress: number;
  environments: string[] = [];
  rows: any[] = []; // Ensure this is initialized

  differencesModal: boolean = false;
  differences: { entity: any, records: any };
  differencesLoaded: boolean = false;

  // percentageChange
  tmpInputValue: any;

  // Render DIFF
  displayRenderDiffDialog: boolean = false;
  diffCheckType: 'simple' | 'user-submission' = 'simple';
  diffCheckRef: string = '';

  allEditTypes: any[] = [
    {
      value: 'overwrite',
      label: 'Overwrite',
      icon: 'fa-clipboard-check',
      description: 'Replaces the existing value with a new one.',
      allowedTypes: ['text', 'long-text', 'rich-text', 'dropdown', 'multiselect', 'date', 'number', 'boolean', 'line-items']
    },
    {
      value: 'line-item-resource',
      label: 'Replace Line Item (Prize, Cost) Resource',
      icon: 'fa-r',
      description: 'Replaces line items Resource with a another resource and maintains original count value.',
      allowedTypes: ['line-items']
    },
    {
      value: 'line-item-count',
      label: 'Replace Line Item (Prize, Cost) Count Value',
      icon: 'fa-plus-minus',
      description: 'Replaces line items Count value and maintains the original type.',
      allowedTypes: ['line-items']
    },
    {
      value: 'clear',
      label: 'Clear',
      icon: 'fa-eraser',
      description: 'Clears the existing value.',
      allowedTypes: ['text', 'long-text', 'rich-text', 'dropdown', 'multiselect', 'date', 'number', 'line-items']
    },
    {
      value: 'find-and-replace',
      label: 'Find and Replace',
      icon: 'fa-right-left',
      description: 'Finds a specific string and replaces it with another. (Leave replacement empty to remove a value)',
      allowedTypes: ['text', 'long-text', 'rich-text']
    },
    {
      value: 'append',
      label: 'Append',
      icon: 'fa-right-to-bracket',
      description: 'Appends a specific value to the end of a field\'s existing value.',
      allowedTypes: ['text', 'long-text', 'rich-text']
    },
    {
      value: 'add',
      label: 'Add',
      icon: 'fa-right-to-bracket',
      description: 'Add a specific value to the end of a field\'s existing value.',
      allowedTypes: ['multiselect']
    },
    {
      value: 'remove',
      label: 'Remove',
      icon: 'fa-eraser',
      description: 'Removes selected values from a multiselect field.',
      allowedTypes: ['multiselect']
    },
    {
      value: 'prepend',
      label: 'Prepend',
      icon: 'fa-right-to-bracket fa-rotate-180',
      description: 'Appends a specific value to the beginning of a field\'s existing value.',
      allowedTypes: ['text', 'long-text', 'rich-text']
    },
    {
      value: 'percentageChange',
      label: 'Cost Percentage Change',
      icon: 'fa-percent',
      description: 'Increases or Decreases Costs by a Percentage',
      allowedTypes: ['line-items']
    }
  ];

  includeVerifiedClientStrings: boolean = false;
  onlyUntranslatedClientStrings: boolean = false;

  findReplaceDialogVisible = false;
  findReplaceStep: 'form' | 'preview' = 'form';
  findReplaceFind = '';
  findReplaceReplace = '';
  findReplaceMatchMode: 'exact' | 'partial' = 'exact';
  findReplaceLanguages: string[] = ['Source_en'];
  findReplaceTriggerLocalization = false;
  findReplaceIncludeVerified = false;
  findReplaceLoading = false;
  findReplaceTotalRecords = 0;
  findReplaceTruncated = false;
  findReplaceSkippedVerified = 0;
  findReplaceWillOverwrite = false;
  findReplaceExpectedIds: string[] = [];
  findReplacePreviewRows: Array<{
    id: string;
    language: string;
    languageLabel: string;
    before: string;
    after: string;
    verified: boolean;
  }> = [];
  findReplaceMatchModeOptions = [
    { label: 'Exact Match', value: 'exact' },
    { label: 'Partial Match', value: 'partial' },
  ];
  findReplaceLanguageOptions = [
    { label: 'English', value: 'Source_en' },
    { label: 'French (France)', value: 'Target_frFR' },
    { label: 'Spanish (Mexico)', value: 'Target_esMX' },
    { label: 'German', value: 'Target_deDE' },
  ];

  // STORE
  private destroy$ = new Subject<void>();

  /**
   * Bulk edits write through the table's controller, so they need update on it. A table that names
   * no `permissionController` keeps them, as before (CMS-6343).
   */
  get canBulkUpdate(): boolean {
    const controller = this.tableParams?.permissionController;
    return !controller || this.authService.hasPermission(['update'], controller);
  }

  get editTypes() {
    if (!this.selectedBulkEditColumns || this.selectedBulkEditColumns.length === 0) {
      return [];
    }
    // If multiple columns are selected, we'll use the type of the first one as a reference
    const selectedColumnType = this.selectedBulkEditColumns[0].type;

    return this.allEditTypes.filter(type => type.allowedTypes.includes(selectedColumnType));
  }

  get selectedRows() {
    return this.rowsSelected.map(rowNode => {
      return rowNode.data;
    });
  }

  get isFindReplaceEnglishSelected(): boolean {
    return (this.findReplaceLanguages || []).includes('Source_en');
  }

  get canPreviewFindReplace(): boolean {
    return !!this.findReplaceFind && (this.findReplaceLanguages || []).length > 0 && !this.findReplaceLoading;
  }

  get canApplyFindReplace(): boolean {
    return this.findReplacePreviewRows.length > 0
      && !this.findReplaceLoading
      && !this.findReplaceTruncated
      && this.findReplaceExpectedIds.length > 0;
  }

  get findReplaceDialogWidth(): string {
    return this.findReplaceStep === 'preview' && this.findReplacePreviewRows.length > 0 ? '70vw' : '520px';
  }

  /**
   * Asynchronously fetches the selected rows based on the current state of row selection.
   *
   * This function checks the `isSelectAll` property and the total number of records to decide
   * whether it should fetch all rows from the backend or just use the currently loaded rows.
   *
   * @param {string} select - Specifies which fields to include in the results, defaults to '_id id name'.
   *                          It is a string with space-separated field names.
   *
   * @param {any} smartPopulate - An object containing advanced options for populating related fields,
   *                              defaults to an empty object.
   *
   * @returns {Promise<any[]>} A Promise that resolves with an array of the selected records.
   *
   * @async
   * @example
   *
   * const selectedData = await getSelectedRows('_id name age', { populate: 'address' });
   */
  async getSelectedRows(select: string = '_id id name', populate: any = null) {
    const populateToUse = this.mergePopulate(populate, this.populateFields);
    select = this.appendPopulatePathsToSelect(select, populateToUse);
    if (this.isSelectAll && this.loadedRowCount !== this.totalRecords) {
      return await this.fetchAllRowsFromBackend(select, null, {populate: populateToUse}, this.isSelectAll);
    } else {
        this.loggerService.debug('Discrepancy between selectedRowCount and rowsSelected', {
          selectedRowsSetSize: this.selectedRowsSet.size,
          rowsSelectedLength: this.rowsSelected.length
        }, 'AgTableActionsComponent');
        return await this.fetchAllRowsFromBackend(select, this.selectedRowsSet, {populate: populateToUse});
    }
  }

  /**
   * Caller populate (e.g. imagePopulate) wins on matching paths; column populateFields
   * fill in any refs the caller did not specify.
   */
  private mergePopulate(explicit: any, fallback: any): any[] {
    const toArr = (value: any): any[] => {
      if (!value) {
        return [];
      }
      return (Array.isArray(value) ? value : [value]).filter(Boolean).flat();
    };
    const explicitArr = toArr(explicit);
    const fallbackArr = toArr(fallback);
    if (explicitArr.length === 0) {
      return fallbackArr;
    }
    if (fallbackArr.length === 0) {
      return explicitArr;
    }
    const byPath = new Map<string, any>();
    fallbackArr.forEach((pop: any) => {
      if (pop?.path) {
        byPath.set(pop.path, pop);
      }
    });
    explicitArr.forEach((pop: any) => {
      if (pop?.path) {
        byPath.set(pop.path, pop);
      }
    });
    return Array.from(byPath.values());
  }

  /**
   * Mongoose drops a ref unless it is in `select`, so populate of image_ref/scene_ref
   * would otherwise return rows without `path` and skip the build.
   */
  private appendPopulatePathsToSelect(select: string, populate: any): string {
    if (!Array.isArray(populate)) {
      return select;
    }
    const fields = new Set(select.split(/\s+/).filter(Boolean));
    populate.forEach((pop: any) => {
      if (pop?.path) {
        fields.add(pop.path);
      }
    });
    return Array.from(fields).join(' ');
  }

  public changesPreview: {
    [id: string]: {
      selected: unknown; original: any, new: any, selectedColumn: string
    }
  } = {};

  ngOnInit(): void {
    this.rowsSelected = [];

    this.tableCommunicationService.addToCart$
      .pipe(takeUntil(this.destroy$))
      .subscribe((type: string) => {
        this.addToCart(type);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setEnvironmentName(): void {
    this.environmentName = EnvironmentService.getEnvironmentName();
  }

  setEnvironmentsArray(): void {
    switch (this.environmentName) {
      case 'production':
        this.environments = ['dev', 'qa', 'prod'];
        break;
      case 'test':
        this.environments = ['test'];
        break;
      case 'development':
        this.environments = ['dev', 'test', 'qa', 'prod'];
        break;
      default:
        this.environments = ['dev', 'test', 'qa', 'prod'];
        break;
    }
  }

  show(): void {
    this.display = true;
  }

  hide(): void {
    this.display = false;
  }

  exportToCSV(type: string) {
    this.ngZone.runOutsideAngular(() => {
      this.spinnerService.loadSpinner();
    });

    let columnsToExport = [];
    const allColumns = this.columnApi.getAllGridColumns(); // Fetch all column definitions
    const getColumnDetails = (colId: any) => {
      const column = allColumns.find((col: any) => col.getColId() === colId);
      return column ? {
        colId: column.getColId(),
        colName: column.getUserProvidedColDef().headerName
      } : null;
    };

    switch (type) {
      case 'current':
        // Exporting only currently selected columns
        let currentDisplayedColumns = this.columnApi.getAllDisplayedColumns();
        columnsToExport = currentDisplayedColumns.map((col: any) => ({
          colId: col.getColId(),
          colName: col.getUserProvidedColDef().headerName
        })).filter((colObj: any) => colObj.colId !== 'actions');
        break;
      case 'organic':
        const organicColumns = [
          'id', 'thumbnail', 'fileName', 'name', 'cultivar', 'batch_ref', 'climates_ref',
          'category_ref', 'start', 'vendorStatus', 'itemStatus', 'costs_ref',
          'enabled', 'buildStatus', 'imageBuildStatus',
        ];
        columnsToExport = organicColumns.map(getColumnDetails).filter(colObj => colObj);
        break;
      case 'hard-surface':
        const hardSurfaceColumns = [
          'id', 'thumbnail', 'fileName', 'name', 'category_ref', 'start', 'vendorStatus', 'itemStatus', 'costs_ref',
          'enabled', 'buildStatus', 'imageBuildStatus', 'contentHold_ref', 'styles_ref', 'colors_ref',
        ];
        columnsToExport = hardSurfaceColumns.map(getColumnDetails).filter(colObj => colObj);
        break;
      default:
        const defaultColumns = ['id', 'name', 'enabled', 'start', 'end', 'env'];
        columnsToExport = defaultColumns.map(getColumnDetails).filter(colObj => colObj);
        break;
    }

    // Construct the request payload
    const payload = {
      query: this.mongoQuery,
      sort: this.mongoSort,
      columns: columnsToExport
    };

    // Determine the correct endpoint based on whether this is a dynamic entity
    const isDynamicEntity = this.tableParams?.isDynamicEntity || false;
    const csvEndpoint = isDynamicEntity 
      ? `api/dynamic-entities/manager/${this.entity}/csv`
      : `api/${this.entity}/csv`;

    // Make an HTTP POST request
    this.httpClient.post(csvEndpoint, payload, { responseType: 'text' })
      .subscribe({
        next: (csv) => {
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
          }).replace(/\//g, '-');

          // Construct the file name
          const fileName = `${this.entity}-${formattedDate}.csv`;

          // Trigger file download
          const blob = new Blob([csv], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          this.spinnerService.endSpinner();
        },
        error: (error) => {
          this.spinnerService.endSpinner();

          if (error.status === 403) {
            let errorMessage = error?.error?.error;

            if (typeof error?.error === 'string') {
              try {
                const errorJson = JSON.parse(error?.error);
                errorMessage = errorJson.error;
              } catch (_) {}
            }

            this.messageService.add({
              sticky: false,
              severity: 'error',
              summary: `ERROR exporting`,
              detail: errorMessage || error.statusText,
            });
          } else {
            alert('Error downloading CSV');
          }
          this.loggerService.error('Error downloading CSV', error, 'AgTableActionsComponent');
        }
        // Optionally, you can add a complete callback if needed
      });

  }

  async toggleAddItemsToCollection(type: string) {
    await this.getAllCollections();
    // Avoid nested modal overlays — they break PrimeNG dropdown positioning on mobile.
    this.display = false;
    this.addToCollectionDialogVisible = true;
  }

  onCollectionDropdownShow(): void {
    // PrimeNG absolutePosition adds document scroll to viewport coords, which misplaces
    // appendTo=body panels inside stacked dialogs. Re-anchor with fixed viewport coords.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.repositionCollectionDropdownPanel());
    });
  }

  private repositionCollectionDropdownPanel(): void {
    const trigger = this.collectionDropdown?.el?.nativeElement as HTMLElement | undefined;
    const panel = this.getCollectionDropdownOverlay();
    if (!trigger || !panel) {
      return;
    }

    const padding = 12;
    const triggerRect = trigger.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const maxWidth = viewportWidth - padding * 2;

    panel.style.position = 'fixed';
    panel.style.transform = 'none';
    panel.style.minWidth = `${triggerRect.width}px`;
    panel.style.width = `${Math.min(Math.max(triggerRect.width, 254), maxWidth)}px`;

    const panelHeight = panel.getBoundingClientRect().height || 240;
    let top = triggerRect.bottom;
    if (top + panelHeight > viewportHeight - padding) {
      top = Math.max(padding, triggerRect.top - panelHeight);
    }

    let left = triggerRect.left;
    const panelWidth = panel.getBoundingClientRect().width || triggerRect.width;
    if (left + panelWidth > viewportWidth - padding) {
      left = Math.max(padding, viewportWidth - padding - panelWidth);
    }
    if (left < padding) {
      left = padding;
    }

    panel.style.top = `${top}px`;
    panel.style.left = `${left}px`;
  }

  private getCollectionDropdownOverlay(): HTMLElement | null {
    const overlay = this.collectionDropdown?.overlayViewChild?.overlayEl as
      | HTMLElement
      | undefined;
    if (overlay) {
      return overlay;
    }

    const innerPanel = document.querySelector(
      '.collection-dropdown-panel.p-dropdown-panel',
    ) as HTMLElement | null;
    return (innerPanel?.closest('.p-overlay') as HTMLElement | null) ?? innerPanel;
  }

  async toggleAddItemsToItemSet() {
    await this.getAllItemSets();
    this.display = false;
    this.addToItemSetDialogVisible = true;
  }


  renderPreview() {
    // Logic for rendering a preview
    this.loggerService.debug('Rendering preview', null, 'AgTableActionsComponent');
  }

  buildProject() {
    // Logic for building a project
    this.loggerService.debug('Building project', null, 'AgTableActionsComponent');
  }

  promoteNow(type: string) {
    // Logic for promotion
    this.loggerService.debug('Promoting', { type }, 'AgTableActionsComponent');
  }

  // BULK EDITING
  toggleBulkEdit() {
    this.bulkEditDialogVisible = true;
  }

  goNext() {
    switch (this.bulkEditState) {
      case 'select-column':
        if (!this.selectedBulkEditColumns || this.selectedBulkEditColumns.length === 0) {
          alert('Please select a column to bulk edit.');
          return;
        }
        this.bulkEditState = 'select-edit-type';
        this.bulkEditStep = 1;
        break;

      case 'select-edit-type':
        if (!this.editType) {
          alert('Please select an edit type to continue.');
          return;
        }
        this.bulkEditState = 'edit-values';
        this.bulkEditStep = 2;
        break;

      case 'edit-values':
        if (this.bulkEditInput.regexError) {
          alert(this.bulkEditInput.regexError);
          return;
        }
        this.createChangesPreview();
        this.bulkEditState = 'verify-changes';
        this.bulkEditStep = 3;
        break;

      default:
        this.loggerService.error('Unexpected bulkEditState', this.bulkEditState, 'AgTableActionsComponent');
        break;
    }
  }

  goBack() {
    switch (this.bulkEditState) {
      case 'select-column':
        alert('Cannot go back');
        break;
      case 'select-edit-type':
        this.bulkEditState = 'select-column';
        this.bulkEditStep = 0;
        break;
      case 'edit-values':
        this.bulkEditState = 'select-edit-type';
        this.bulkEditStep = 1;
        break;
      case 'verify-changes':
        this.bulkEditState = 'edit-values';
        this.bulkEditStep = 2;
        break;
      default:
        this.bulkEditState = 'select-column';
        this.bulkEditStep = 0;
        break;
    }
  }

  cancelBulkEdit() {
    this.bulkEditDialogVisible = false;
    // When submitBulkEdit() closes the dialog to show the success dialog, onHide fires
    // this method. Skip clearing state so the success dialog can still read field/editType.
    if (this.showSuccessDialog) return;
    this.bulkEditState = 'select-column';
    this.bulkEditStep = 0;
    this.selectedBulkEditColumns = [];
    this.editType = null;
  }

  getSelectedColumn(): any {
    return this.selectedBulkEditColumns[0];
  }

  getSelectedColumnDef(): any {
    let col = this.getSelectedColumn();
    return this.getColumnDefinitionById(col.id);
  }

  getColumnDefinitionById(columnId: string): any {
    const column = this.columnApi.getColumn(columnId);
    return column ? column.getColDef() : null;
  }

  updateSelectedRows(): void {
    this.rowsSelected = Object.keys(this.changesPreview)
      .filter(key => this.changesPreview[key].selected)
      .map(key => key);
    this.areRowsSelected = this.rowsSelected.length > 0;
  }


  removeSelectedRows(): void {
    this.rowsSelected.forEach(selectedId => {
      if (this.changesPreview[selectedId]) {
        delete this.changesPreview[selectedId];
      }
    });
    this.updateSelectedRows();
  }



  getOriginalValue(value: any, columnType: string): any {
    this.loggerService.debug('getOriginalValue', { value, columnType }, 'AgTableActionsComponent');

    if (value !== null && value !== undefined) {
      return value;
    }

    switch (columnType) {
      case 'text':
      case 'long-text':
      case 'rich-text':
        return '';
      case 'dropdown':
      case 'date':
        return null;
      case 'multiselect':
        return [];
      default:
        return value;
    }
  }

  async createChangesPreview() {
    this.isLoading = true;
    this.spinner.show();

    try {
        this.changesPreview = {};  // Clear any previous data
        const inputValue = this.bulkEditInput.getValue();
        this.tmpInputValue = inputValue;
        this.capturedInputOptions = this.bulkEditInput.inputOptions ? [...this.bulkEditInput.inputOptions] : [];
        let selectedColumn = this.getSelectedColumn();

        let selectionParams = this.getSelectionParams(selectedColumn);
        const selectedRows = await this.getSelectedRows(selectionParams.select);

        // Process rows in parallel batches
        const batchSize = 50; // Adjust based on your needs
        const batches = [];

        // Create batches of rows
        for (let i = 0; i < selectedRows.length; i += batchSize) {
            batches.push(selectedRows.slice(i, i + batchSize));
        }

        // Process each batch in parallel
        await Promise.all(batches.map(async (batchRows) => {
            const batchResults = batchRows.map((row: any) => {
                const rowData = row;
                const id = row.id;
                let originalValue = this.getOriginalValue(rowData[selectedColumn.id], selectedColumn.type);
                let newValue;

                switch (this.editType.value) {
                    case 'overwrite':
                        if ('date' == selectedColumn.type) {
                            newValue = new Date(inputValue).toISOString();
                        } else if ('line-items' == selectedColumn.type) {
                            newValue = inputValue;
                        } else {
                            newValue = inputValue;
                        }
                        break;

                    case 'clear':
                        newValue = Array.isArray(originalValue) ? [] : '';
                        break;

                    case 'find-and-replace':
                        if (['text', 'long-text', 'rich-text'].includes(selectedColumn.type) && inputValue.find && inputValue.replace) {
                            const pattern = inputValue.useRegex ? new RegExp(inputValue.find, 'g') : inputValue.find;
                            newValue = originalValue.replace(pattern, inputValue.replace);
                        } else {
                            newValue = originalValue;
                        }
                        break;

                    case 'append':
                        if (['text', 'long-text', 'rich-text'].includes(selectedColumn.type)) {
                            newValue = originalValue + inputValue;
                        } else if (Array.isArray(originalValue)) {
                            newValue = [...originalValue, inputValue];
                        } else {
                            newValue = originalValue;
                        }
                        break;

                    case 'add':
                        if (['multiselect'].includes(selectedColumn.type) && Array.isArray(originalValue) && Array.isArray(inputValue)) {
                            let combinedArray = [...originalValue, ...inputValue];
                            let uniquePrimitives = new Set();
                            let uniqueObjects = new Map();

                            combinedArray.forEach(item => {
                                if (typeof item === 'object' && item !== null && '_id' in item) {
                                    uniqueObjects.set(item._id, item);
                                } else {
                                    uniquePrimitives.add(item);
                                }
                            });

                            newValue = [...Array.from(uniquePrimitives), ...Array.from(uniqueObjects.values())];
                        } else {
                            newValue = originalValue;
                        }
                        break;

                    case 'remove':
                        if (['multiselect'].includes(selectedColumn.type) && Array.isArray(originalValue) && Array.isArray(inputValue)) {
                            const valuesToRemove = new Set(
                                inputValue.map((item: any) => {
                                    if (typeof item === 'object' && item !== null && '_id' in item) {
                                        return item._id;
                                    }
                                    return item;
                                })
                            );

                            newValue = originalValue.filter((item: any) => {
                                if (typeof item === 'object' && item !== null && '_id' in item) {
                                    return !valuesToRemove.has(item._id);
                                }
                                return !valuesToRemove.has(item);
                            });
                        } else {
                            newValue = originalValue;
                        }
                        break;

                    case 'prepend':
                        if (['text', 'long-text', 'rich-text'].includes(selectedColumn.type)) {
                            newValue = inputValue + originalValue;
                        } else if (Array.isArray(originalValue)) {
                            newValue = [inputValue, ...originalValue];
                        } else {
                            newValue = originalValue;
                        }
                        break;

                    case 'line-item-resource':
                        newValue = originalValue.map((item: any) => {
                            return {
                                id: inputValue.id ? inputValue.id : null,
                                t: inputValue.t ? inputValue.t : null,
                                lineItemType: inputValue.lineItemType,
                                c: item.c
                            };
                        });
                        break;

                    case 'line-item-count':
                        // Use map to create a new array (newValue) with the updated field
                        newValue = originalValue.map((item: any) => {
                            // Update the 'count' field
                            const updatedCount = inputValue;
                            // Return the object with the updated 'count' field
                            return {
                                ...item, // Spread the existing properties of the object
                                c: updatedCount, // Update the 'count' field
                            };
                        });
                        break;

                    case 'percentageChange':
                        // Use map to create a new array (newValue) with the updated field
                        newValue = originalValue.map((item: any) => {
                            // Calculate the percentage change
                            const percentageChange = item.c * (inputValue.value / 100);

                            // Update the 'count' field based on the direction
                            let updatedCount = inputValue.direction === 'increase'
                                ? item.c + percentageChange
                                : item.c - percentageChange;

                            // Apply custom rounding
                            updatedCount = this.customRound(updatedCount);

                            // Return the object with the updated 'count' field
                            return {
                                ...item, // Spread the existing properties of the object
                                c: updatedCount, // Update the 'count' field
                            };
                        });
                        break;

                    default:
                        newValue = originalValue;
                        break;
                }

                return {
                    id,
                    preview: {
                        original: originalValue,
                        new: newValue,
                        selectedColumn: selectedColumn.id,
                        selected: false,
                    }
                };
            });

            // Batch update changesPreview
            batchResults.forEach((result: any) => {
                this.changesPreview[result.id] = result.preview;
            });
        }));

    } catch (error) {
        this.loggerService.error('Error loading changes preview', error, 'AgTableActionsComponent');
    } finally {
        this.isLoading = false;
        this.spinner.hide();
    }
  }

  customRound(value: number) {
    // Find the nearest 10th
    const nearestTenth = Math.floor(value / 10) * 10;

    // Calculate the remainder
    const remainder = value % 10;

    if (remainder < 5) {
      // If the remainder is less than 5, round down to the nearest lower 10th
      return nearestTenth;
    } else {
      // If the remainder is 5 or more, round up to the nearest upper 10th
      return nearestTenth + 10;
    }
  }

  getSelectionParams(selectedColumn: any) {
    const defaultFields = ['_id', 'id', 'name'];
    let select: string;
    let smartPopulate: any = {};

    // Remove duplicates by converting the array to a Set and back to an array
    const uniqueDefaultFields = [...new Set([...defaultFields, selectedColumn.id])];

    // Create the select string
    select = uniqueDefaultFields.join(' ');

    // Check if smartPopulate should be enabled
    if (selectedColumn.smartPopulate) {
      // Create an initial Set with default fields for unique entry
      const smartFieldsSet = new Set(defaultFields);

      // Add optionLabel and optionValue if they are defined
      if (selectedColumn.optionLabel) {
        smartFieldsSet.add(selectedColumn.optionLabel);
      }
      if (selectedColumn.optionValue) {
        smartFieldsSet.add(selectedColumn.optionValue);
      }

      // Convert Set back to array and join it to form a string
      const smartFieldsArray = Array.from(smartFieldsSet);
      smartPopulate[selectedColumn.id] = smartFieldsArray.join(' ');
    }

    return { select, smartPopulate };
  }

  get changeKeys() {
    return this.changesPreview ? Object.keys(this.changesPreview) : [];
  }


    async submitBulkEdit() {
        const selectedColumn = this.getSelectedColumn();
        const changesPreview = this.changesPreview;
        this.submitInProgress = true;
        this.progress = 0;
        this.rowStatus = {};
        this.successfulEdits = [];
        this.failedEdits = [];

        try {
            const keys = Object.keys(changesPreview);
            const totalItems = keys.length;
            keys.forEach(k => (this.rowStatus[k] = 'pending'));
            this.cdr.detectChanges();

            // Each chunk is ONE request to the API's bulk-update endpoint, sized to the server's
            // per-request cap. At 500 rows a request, reaching the 100-req/min throttle would take
            // a 50,000-row edit; the old 100-row chunking got there at 10,000. Entities that run
            // update automations per row use smaller chunks to keep each request short.
            const chunkSize = this.agGridEditService.getBulkChunkSize(this.entity, this.tableParams?.isDynamicEntity || false);
            let processedItems = 0;

            for (let i = 0; i < totalItems; i += chunkSize) {
                const chunkKeys = keys.slice(i, i + chunkSize);
                chunkKeys.forEach(k => (this.rowStatus[k] = 'saving'));
                this.cdr.detectChanges();

                const chunk = this.getBatchFromKeys(changesPreview, chunkKeys);
                const result = await this.agGridEditService.submitBulkEdit(
                    this.gridApi,
                    chunk,
                    selectedColumn,
                    this.changedRows,
                    this.entity,
                    this.tableParams?.isDynamicEntity || false,
                    true,
                );

                // Trust the server's per-record verdict rather than assuming the whole chunk
                // landed: reporting unsaved rows as "done" is what made the old bulk edit claim
                // success while leaving rows untouched.
                const updated = new Set(result.updated.map(id => String(id)));
                for (const key of chunkKeys) {
                    if (updated.has(key)) {
                        this.rowStatus[key] = 'done';
                        this.successfulEdits.push(key);
                    } else {
                        this.rowStatus[key] = 'error';
                    }
                }
                this.failedEdits.push(...result.failed.map(f => ({ id: String(f.id), error: f.error })));

                processedItems += chunkKeys.length;
                this.progress = Math.floor((processedItems / totalItems) * 100);
                this.cdr.detectChanges();
                await new Promise(resolve => setTimeout(resolve, 0));
            }

            this.gridApi.refreshServerSide();

            // Show the result dialog — keep selectedBulkEditColumns/editType alive so it can
            // display field/operation labels; they are cleared in closeSuccessDialog().
            this.showSuccessDialog = true;
            this.bulkEditDialogVisible = false;
        } catch (error) {
            this.loggerService.error('Bulk edit error', error, 'AgTableActionsComponent');
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to complete bulk edit operation'
            });
        } finally {
            this.submitInProgress = false;
            this.progress = 0;
            this.rowStatus = {};
        }
    }

    private getBatchFromKeys(changesPreview: any, keys: string[]): any {
        const batch: {[key: string]: any} = {};
        for (const key of keys) {
            batch[key] = changesPreview[key];
        }
        return batch;
    }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  getFieldTypeSeverity(type: string): string | null {
    const map: Record<string, string | null> = {
      'text': 'info',
      'long-text': 'info',
      'rich-text': 'info',
      'number': 'warning',
      'boolean': 'success',
      'date': 'warning',
      'dropdown': null,
      'multiselect': 'danger',
      'line-items': 'danger',
    };
    return map[type] ?? null;
  }

  isEmptyNewValue(id: string): boolean {
    const val = this.changesPreview[id]?.new;
    if (val === null || val === undefined || val === '') return true;
    if (Array.isArray(val) && val.length === 0) return true;
    return false;
  }

  formatValue(value: any): any {
    let selectedColumn = this.getSelectedColumn();
    switch (selectedColumn.type) {
      case 'date':
        if (!value) return '';
        let date = new Date(value);
        const options: Intl.DateTimeFormatOptions = {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        };
        return new Intl.DateTimeFormat('en-US', options).format(date);
      case 'boolean':
        return value ? selectedColumn.onLabel : selectedColumn.offLabel;
      case 'dropdown':
        if (selectedColumn.isFlatList) {
          return value && value.label ? value.label : value;
        } else {
          if (value && value.name && value.id) {
            return `${value.name} (${value.id})`;
          } else if (value) {
            // value is a raw _id string (from a reference dropdown using optionValue: "_id")
            // use the snapshot taken during createChangesPreview() while bulkEditInput was alive
            const option = this.capturedInputOptions.find((opt: any) => opt._id === value || opt.id === value);
            return option ? `${option.name} (${option.id})` : value;
          }
          return value;
        }
      default:
        return value;
    }
  }
  async getAllItemSets() {
    if (this.itemSets.length > 1) {
      return;
    } else {
      let result = await this.commonEntityService.findAllWithQuery('item-sets', { query: {}, select: 'name id _id', autopopulate: false, virtuals: false, sort: { id: -1 } });
      if (result) {
        this.itemSets = result;
      }
    }
  }


  // Add To Collections Functionality
  async getAllCollections() {
    let result;
    if (this.collections.length > 1) {
      return;
    } else {
      if(this.entity == 'challenges') {
        result = await this.commonEntityService.findAllWithQuery('challenge-collections', { query: {}, select: 'name id _id', autopopulate: false, virtuals: false, sort: { id: -1 } });
      } else {
        result = await this.commonEntityService.findAllWithQuery('collections', { query: {}, select: 'name id _id', autopopulate: false, virtuals: false, sort: { id: -1 } });
      }

      if (result) {
        this.collections = result;
      }
    }
  }

  /**
   * Upload Sourcing Items to collection
   */
  async addToCollection(type: string) {
    this.spinnerService.loadSpinner();

    try {
      const itemsToAdd = this.rowsSelected.map(rowNode => ({
        id: rowNode.data.id,
        _id: rowNode.data._id,
      }));

      let result;
      if (this.entity == 'challenges') {
        result = await this.challengeService.uploadToCollection({ collectionId: this.selectedCollection, sourcingItems: itemsToAdd, existingItem: false });
      } else {
        result = await this.itemService.uploadToCollection({ collectionId: this.selectedCollection, sourcingItems: itemsToAdd, existingItem: false });
      }

      if (result) {
        if (result.Success) {
          this.addToCollectionDialogVisible = true;
          this.messageService.add({
            sticky: true,
            severity: 'success',
            summary: 'Success',
            detail: `Uploaded ${this.entity} were successfully uploaded to collection.`,
          });
        } else {
          this.messageService.add ({
            sticky: true,
            severity: 'error',
            summary: 'Error',
            detail: 'No Collection Selected.',
          });
        }
      } else {
        this.messageService.add({
          sticky: true,
          severity: 'error',
          summary: 'API Error',
          detail: 'There is an error in the API request.',
        });
      }
    } catch (error: any) {
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error.error || error);
      this.showMessage('error', 'API Error', errorMessage);
    }

    this.spinnerService.endSpinner();
    this.addToCollectionDialogVisible = false
  }

  /**
   * Upload Sourcing Items to collection
   */
  async createAndAddToCollection() {
    if (this.isCreatingCollection) return;
    this.isCreatingCollection = true;
    try {
      this.spinnerService.loadSpinner();
      const itemsToAdd = this.rowsSelected.map(rowNode => ({
        id: rowNode.data.id,
        _id: rowNode.data._id,
      }));

      let result;

      if (this.entity == 'challenges') {
        this.createCollection.challenges_ref = itemsToAdd;
        result = await this.challengeService.createCollection({ data: this.createCollection });
      } else {
        this.createCollection.items_ref = itemsToAdd;
        result = await this.itemService.createCollection({ data: this.createCollection });
      }

      if (result) {
        if (result.success) {
          this.addToCollectionDialogVisible = false;
          this.messageService.add({
            sticky: true,
            severity: 'success',
            summary: 'Success',
            detail: 'Successfully created a collection and added the items.',
          });
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'error',
            summary: 'Error',
            detail: 'No Collection Created.',
          });
        }
      } else {
        this.messageService.add({
          sticky: true,
          severity: 'error',
          summary: 'API Error',
          detail: 'There is an error in the API request.',
        });
      }
    } catch (error: any) {
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error.error || error);
      this.showMessage('error', 'Conflict Error', errorMessage);
      this.loggerService.error('Error creating collection', error, 'AgTableActionsComponent');
    } finally {
      this.isCreatingCollection = false;
      this.spinnerService.endSpinner();
      this.createCollectionDialogVisible = false;
      this.addToCollectionDialogVisible = false;
    }
  }

  showMessage(severity: string, summary: string, detail: string) {
    this.messageService.add({
      sticky: true,
      severity,
      summary,
      detail
    });
  }

  // BULK BUILD
  /**
   * Pre load need data for bulk build
   *
   * @param array List fo entities to build
   * @param type Entity Type
   * @param assetType Asset type
   */
  async onStartBulkBuild(isAssetBuild: boolean) {
    this.bulkBuildProgress = 0;
    this.display = false;

    let isSelf = false;
    let smartPopulate = {};
    let select = '_id id name';

    if (!this.buildParams) {
      return;
    }

    if (isAssetBuild && this.buildParams.assetKeys.includes('SELF')) {
      isSelf = true;
      select = 'id _id path entityId entityType assetType buildData assetBuildOutput';
    } else if (!isAssetBuild && this.buildParams.imageKeys.includes('SELF')) {
      isSelf = true;
      select = 'id _id path entityId entityType assetType buildData assetBuildOutput imageBuildOutput';
    }

    let populate;
    if (isAssetBuild && this.buildParams.assetPopulate) {
      populate = [this.buildParams.assetPopulate];
    } else if (!isAssetBuild && this.buildParams.imagePopulate) {
      populate = [this.buildParams.imagePopulate];
    }

    select = this.appendPopulatePathsToSelect(select, populate);

    // Get the selected rows using the new function
    const selectedRows = await this.getSelectedRows(select, populate);

    const recordsToBuild = selectedRows.map((row: any) => {
      // Initialize an empty array to hold the build job data
      let buildJobData: any[] = [];

      // Decide which keys to use based on the value of isAssetBuild
      const keys = isAssetBuild ? this.buildParams.assetKeys : this.buildParams.imageKeys;

      if (isSelf) {
        let assetData = row;
        if (assetData && assetData.path) { // Check if obj and obj.path exist
          buildJobData.push({
            path: assetData.path,
            record: assetData
          });
        }
      } else {
        // For each key, extract the path attribute from the object it points to
        keys.forEach((key: any) => {
          let assetData = row[key];
          if (assetData && assetData.path) { // Check if obj and obj.path exist
            buildJobData.push({
              path: assetData.path,
              record: assetData
            });
          }
        });
      }

      return {
        id: row.id,
        _id: row._id,
        name: row.name,
        buildJobData: buildJobData,
        parentRecord: row
      };
    });

    this.bulkBuild.rows = recordsToBuild;
    this.showBulkBuild = true;
  }

  async buildMiscAsset(newHash: boolean = false) {
    try {
      this.loggerService.debug('buildMiscAsset', {
        buildParams: this.buildParams,
        bulkBuild: this.bulkBuild,
        newHash
      }, 'AgTableActionsComponent');

      //
      this.disableBuildButton = true;
      this.bulkBuild.successCount = 0;
      this.bulkBuild.failedPayloads = [];
      this.showBuildProgress = true;
      //
      let bulkBuildId = this.utilitiesService.createGuid();
      this.bulkBuildProgress = 0;
      let count = 0;
      //
      // Guard: only register the Slack notification (which surfaces a bulk build ID)
      // when there is at least one buildable asset. Rows produce empty buildJobData when
      // a selected record has no asset path, which would otherwise queue nothing while
      // still emitting an orphan bulk ID to Slack.
      const totalBuildJobs = this.bulkBuild.rows.reduce(
        (sum: number, row: any) => sum + (row?.buildJobData?.length || 0),
        0
      );
      if (totalBuildJobs === 0) {
        this.messageService.add({
          sticky: true,
          severity: 'warn',
          summary: 'Nothing to Build',
          detail: 'None of the selected rows have a buildable asset (missing asset path).',
        });
        this.showBulkBuild = false;
        this.disableBuildButton = false;
        this.showBuildProgress = false;
        return;
      }
      //
      await this.dataService.bulkNotification(this.userParams.user.email, bulkBuildId);
      //
  
      /**
      * SENDING JOBS TO QUEUE
      * LOOPING THROUGH buildJobRow.buildJobData since some entities have multiple build keys (assetKeys, imageKeys)
      * Example: currencies, loading screens, garden pass, endless offers.. anything with multiple misc.asset refs
      * */
      for (const buildJobRow of this.bulkBuild.rows) {
        if (buildJobRow) {
          for (const buildJobDataItem of buildJobRow.buildJobData) {
            await this.sentToBuildQueue(
              buildJobDataItem.record,
              buildJobDataItem.path,
              buildJobDataItem.record.entityType,
              bulkBuildId,
              buildJobRow.parentRecord,
              newHash
            );
          }
        } else {
          // Assuming you want to add each failed payload for each 'buildJobData'
          // You might need to adjust this part according to your specific requirements
          for (const buildJobDataItem of buildJobRow.buildJobData) {
            this.bulkBuild.failedPayloads.push({
              entityId: buildJobRow.id,
              path: buildJobDataItem.path,
              user: this.userParams.user
            });
          }
        }
  
        count += 1;
        this.bulkBuildProgress = Number(
          ((count / this.bulkBuild.rows.length) * 100).toFixed(2)
        );
      }
  
      //
  
      const dupFailures = this.entity === 'challenges'
        ? this.bulkBuild.failedPayloads.filter(p => p._error?.Type === 'originalDuplicate')
        : [];

      if (dupFailures.length > 0) {
        this.bulkBuild.failedPayloads = this.bulkBuild.failedPayloads.filter(p => p._error?.Type !== 'originalDuplicate');
        this.showBulkBuild = false;
        this.disableBuildButton = false;
        this.showBuildProgress = false;
        await this.confirmAndRetryDuplicates(dupFailures, bulkBuildId, newHash);
      } else {
        if (this.bulkBuild.failedPayloads.length == 0) {
          this.messageService.add({
            severity: 'success',
            summary: 'All Builds Queued',
            detail: `${this.bulkBuild.successCount} items sent to build queue.`,
            life: 4000
          });
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'warn',
            summary: 'Error Queuing Builds',
            detail: `${this.bulkBuild.successCount} items sent to build queue & ${this.bulkBuild.failedPayloads.length} errors.`,
          });
        }
        this.showBulkBuild = false;
        this.disableBuildButton = false;
        this.showBuildProgress = false;
      }
    } catch (error: any) {
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error);
      this.showMessage('error', 'API Error', errorMessage);
      this.showBulkBuild = false;
      this.disableBuildButton = false;
      this.showBuildProgress = false;
    }
  }

  private async confirmAndRetryDuplicates(dupFailures: any[], bulkBuildId: string, newHash: boolean) {
    this.dupFailuresForConfirm = dupFailures;
    this.showDupConfirmDialog = true;
    return new Promise<void>(resolve => {
      this._dupConfirmContext = { bulkBuildId, newHash, resolve };
    });
  }

  async onDupConfirmAccept() {
    if (!this._dupConfirmContext) return;
    const { bulkBuildId, newHash, resolve } = this._dupConfirmContext;
    this.showDupConfirmDialog = false;
    for (const failed of this.dupFailuresForConfirm) {
      const { _error, ...payload } = failed;
      await this.sentToBuildQueue(
        payload.entity,
        payload.path,
        payload.buildType,
        bulkBuildId,
        { id: payload.parentRecordId },
        newHash,
        true
      );
    }
    this.showBuildToast();
    this._dupConfirmContext = null;
    resolve();
  }

  onDupConfirmReject() {
    if (!this._dupConfirmContext) return;
    const { resolve } = this._dupConfirmContext;
    this.showDupConfirmDialog = false;
    this.bulkBuild.failedPayloads.push(...this.dupFailuresForConfirm);
    this.showBuildToast();
    this._dupConfirmContext = null;
    resolve();
  }

  private showBuildToast() {
    if (this.bulkBuild.failedPayloads.length === 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'All Builds Queued',
        detail: `${this.bulkBuild.successCount} items sent to build queue.`,
        life: 4000
      });
    } else {
      this.messageService.add({
        sticky: true,
        severity: 'warn',
        summary: 'Error Queuing Builds',
        detail: `${this.bulkBuild.successCount} items sent to build queue & ${this.bulkBuild.failedPayloads.length} errors.`,
      });
    }
  }

  async requestBulkAssetStatusCheck(type: 'render-diff' | 'promotionStatus') {
    let select = '_id id name';
    let jobId = uuidv4();
    if (this.entity === 'items') {
      select += ' prefab_ref';
    } else if (this.entity === 'challenges') {
      select += ' scene_ref';
    }
    const selectedRows = await this.getSelectedRows(select);
    this.loggerService.debug('requestBulkAssetStatusCheck selectedRows', selectedRows, 'AgTableActionsComponent');
    try {
      this.spinnerService.loadSpinner();
      for (const row of selectedRows) {
        let payload = {
          entity: {
            id: row.id,
            _id: row._id,
            name: row.name,
            miscAsset_ref: this.entity === 'items' ? row.prefab_ref._id : this.entity === 'challenges' ? row.scene_ref._id : null,
          },
          buildType: this.entity === 'items' ? BuildType.Items : this.entity === 'challenges' ? BuildType.Levels : null,
          slackUserId: null,
          jobType: type,
          jobId: jobId,
          diffType: type == 'render-diff' ? this.diffCheckType : null,
          diffRef: type == 'render-diff' ? this.diffCheckRef : null,
        };
        await this.dataService.insertRenderDiffJob(payload);
      }
      this.messageService.add({
        severity: 'success',
        summary: 'Render Diff Job Queued',
        detail: `${selectedRows.length} items sent to render diff queue.`,
        life: 1400
      });
      this.spinnerService.endSpinner();
    } catch (error: any) {
      this.loggerService.error('Error occurred while inserting render diff job', error, 'AgTableActionsComponent');
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : 'An error occurred while inserting render diff job.';
      this.messageService.add({
        severity: 'error',
        summary: 'Error Queuing Render Diff Job',
        detail: errorMessage,
        life: 1400
      });
      this.spinnerService.endSpinner();
    }

    this.displayRenderDiffDialog = false;
    this.diffCheckRef = '';
  }

  /**
   * Send the build job request to build queue
   */
  async sentToBuildQueue
    (
      entity: any,
      path: string,
      buildQueueType: BuildType,
      bulkBuildId: any,
      parentRecord: any = null,
      newHash: boolean = false,
      skipDupCheck: boolean = false,
    ) {
    interface userData {
      [key: string]: any;
    }
    // populating userPayload with current users's data
    let userPayload: userData = {};
    userPayload.email = this.userParams.user.email;
    userPayload.name = this.userParams.user.name;
    userPayload.id = this.userParams.user.id;

    var payload =
    {
      path: path,
      recursive: true,
      buildType: buildQueueType,
      entityType: entity.entityType,
      assetType: entity.assetType,
      entityId: entity.id,
      user: userPayload,
      isPriority: null,
      bulkBuildId: bulkBuildId,
      isFirstBuild: (entity.buildData && entity.buildData.length > 0) || (entity.assetBuildOutput && Object.keys(entity.assetBuildOutput).length > 0) ? false : true,
      renderAsset: this.buildAndRender,
      parentRecordId: parentRecord ? parentRecord.id : null,
      entity: entity,
      newHash: newHash,
      skipDupCheck: skipDupCheck,
      generateStoreThumb: entity.generateStoreThumb ? true : false
    };

    if (
      payload.path &&
      payload.path.length > 0 &&
      // payload.user &&
      payload.entityId
    ) {
      let response = await this.dataService.sendToBuildQueue(
        buildQueueType,
        payload,
        false
      );
      if (response.Success) {
        this.bulkBuild.successCount++;
      } else {
        this.bulkBuild.failedPayloads.push({ ...payload, _error: response });
      }
    } else {
      this.loggerService.warn('Build payload missing required fields', { path: payload.path }, 'AgTableActionsComponent');
      this.bulkBuild.failedPayloads.push({ ...payload, _error: { Type: 'missingFields', Message: 'path or entityId is empty' } });
    }

    return true;
  }

  /**
  * Display failed payloads
  */
  onShowFailedPayloads() {
    this.showBulkBuildFailed = true;
    this.display = false;
    this.loggerService.debug('Failed payloads', this.bulkBuild.failedPayloads, 'AgTableActionsComponent');
  }

  // BULK PROMOTION

  /**
   * Show the Confirmation Bulk Promotion Dialog,
   * and sets the selected rows.
   *
   * @param selectedRows Rows selected by the user.
   * @param isAssetPromotion Flag that sets whether or not is an asset promotion.
   */
  async startBulkPromotion(isAssetPromotion: boolean) {
    let isSelf = false;

    if (isAssetPromotion && this.buildParams.assetKeys.includes('SELF')) {
      isSelf = true;
    } else if (!isAssetPromotion && this.buildParams.imageKeys.includes('SELF')) {
      isSelf = true;
    }

    let smartPopulate = {};
    let select = '_id id name itemStatus vendorStatus start end flagged';
    if (isSelf) {
      select = 'id _id path entityId entityType assetType buildData buildOutput assetBuildOutput';
    } else if (isAssetPromotion && this.buildParams.assetSmartPopulate) {
      smartPopulate = this.buildParams.assetSmartPopulate;
    } else if (!isAssetPromotion && this.buildParams.imageSmartPopulate) {
      smartPopulate = this.buildParams.imageSmartPopulate;
    }

    let populate;
    if (isAssetPromotion && this.buildParams.assetPopulate) {
      populate = [this.buildParams.assetPopulate];
    } else if (!isAssetPromotion && this.buildParams.imagePopulate) {
      populate = [this.buildParams.imagePopulate];
    }
    select = this.appendPopulatePathsToSelect(select, populate);

    // Get the selected rows using the new function
    const selectedRows = await this.getSelectedRows(select, populate);

    const rowsToPromote = selectedRows.map((row: any) => {
      // Initialize an empty array to hold the build job data
      let buildJobData: any[] = [];

      if (isSelf) {
        const assetData = row;
        if (assetData && assetData.path) { // Check if obj and obj.path exist
          buildJobData.push({
            path: assetData.path,
            record: assetData
          });
        }
      } else {
        // Decide which keys to use based on the value of isAssetBuild
        const keys = isAssetPromotion ? this.buildParams.assetKeys : this.buildParams.imageKeys;

        // For each key, extract the path attribute from the object it points to
        keys.forEach((key: any) => {
          const assetData = row[key];
          if (assetData && assetData.path) { // Check if obj and obj.path exist
            buildJobData.push({
              path: assetData.path,
              record: assetData
            });
          }
        });
      }

      return {
        id: row.id,
        _id: row._id,
        name: row.name,
        buildJobData: buildJobData,
        parentRecord: row
      };

    });

    this.bulkPromote.rows = rowsToPromote;
    this.showBulkPromote = true;
    this.isAssetPromotion = isAssetPromotion;
    this.isCombinedPromotion = false;
    this.loggerService.debug('startBulkPromotion', this.bulkPromote, 'AgTableActionsComponent');
  }

  /**
   * Show the Confirmation Bulk Promotion Dialog for promoting BOTH the assets
   * and images of the selected rows in a single action. Mirrors the individual
   * "Promote Asset & Image" action available on a record's build-data view.
   *
   * Each selected row produces one build job per asset key and one per image
   * key, tagged with `isAsset` so the processor promotes each with the correct
   * build type.
   */
  async startCombinedBulkPromotion() {
    let select = '_id id name itemStatus vendorStatus start end flagged';
    const populate = [
      this.buildParams?.assetPopulate,
      this.buildParams?.imagePopulate,
    ].filter(Boolean);

    select = this.appendPopulatePathsToSelect(select, populate);
    const selectedRows = await this.getSelectedRows(select, populate);

    const rowsToPromote = selectedRows.map((row: any) => {
      const buildJobData: any[] = [];

      // Asset promotion job(s)
      (this.buildParams.assetKeys || []).forEach((key: any) => {
        const assetData = row[key];
        if (assetData && assetData.path) {
          buildJobData.push({ path: assetData.path, record: assetData, isAsset: true });
        }
      });

      // Image promotion job(s)
      (this.buildParams.imageKeys || []).forEach((key: any) => {
        const imageData = row[key];
        if (imageData && imageData.path) {
          buildJobData.push({ path: imageData.path, record: imageData, isAsset: false });
        }
      });

      return {
        id: row.id,
        _id: row._id,
        name: row.name,
        buildJobData: buildJobData,
        parentRecord: row
      };
    });

    this.bulkPromote.rows = rowsToPromote;
    this.showBulkPromote = true;
    this.isCombinedPromotion = true;
    this.isAssetPromotion = false;
    this.loggerService.debug('startCombinedBulkPromotion', this.bulkPromote, 'AgTableActionsComponent');
  }

  /**
   * Handles the bulk promotion of assets or images.
   *
   * @param {boolean} isAssetPromotion - Flag to indicate if the promotion is for assets (true) or images (false).
   * @param {boolean} newHash - Flag to indicate whether to create a new hash during promotion.
   * @async
   */
  async onBulkPromotion(isAssetPromotion: boolean = false, newHash: boolean = false) {
    try {
      // Initialize variables
      this.initializeBulkPromotionState();
  
      let count = 0;
  
      // Loop through each selected row to be promoted
      for (const buildJobRow of this.bulkPromote.rows) {
        let isValid = this.validateAssetPromotion(buildJobRow.parentRecord);
        // Check validation
        if (isValid) {
          // Process each build job data item for the row
          await this.processBuildJobData(buildJobRow, isAssetPromotion, newHash);
        } else {
          this.addFailedPayload('Safety gating validation failed.', buildJobRow.id, buildJobRow.name);
        }
        // Update progress
        this.updateProgress(++count, this.bulkPromote.rows.length);
      }
  
      // Show promotion results
      this.showPromotionResults(isAssetPromotion);
    } catch (error: any) {
      this.showBulkPromote = false;
      this.disablePromoteButton = false;
      this.showPromoteProgress = false;
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error);
      this.messageService.add({ severity: 'error', summary: 'Error promoting!', detail: errorMessage });
    }
  }

  // Initialize the state variables for bulk promotion
  private initializeBulkPromotionState() {
    this.bulkPromoteProgress = 0;
    this.bulkPromote.successCount = 0;
    this.bulkPromote.failedPayloads = [];
    this.disablePromoteButton = true;
    this.showPromoteProgress = true;
  }

  // Process build job data items
  private async processBuildJobData(buildJobRow: any, isAssetPromotion: boolean, newHash: boolean) {
    for (const buildJobDataItem of buildJobRow.buildJobData) {
      // Combined promotions tag each job with `isAsset`; single-mode promotions
      // fall back to the shared `isAssetPromotion` flag.
      const itemIsAsset = buildJobDataItem.isAsset !== undefined ? buildJobDataItem.isAsset : isAssetPromotion;
      const buildType = itemIsAsset ? buildJobDataItem.record.entityType : BuildType.Images;

      try {
        const response = await this.promotionService.onPromoteRecord(
          buildType,
          {
            from: 'dev',
            to: 'prod',
            entity: buildJobDataItem.record,
            buildType: buildType,
            newHash: newHash
          },
          false,
          this.entity
        );

        // Update success or failure counts based on the response
        if (response && response.Success) {
          this.bulkPromote.successCount += 1;
        } else {
          const errorMessage = response && response.AssetResponse && response.AssetResponse.Message
            ? response.AssetResponse.Message
            : 'Error promoting asset.';
          this.addFailedPayload(errorMessage, buildJobRow.id, buildJobRow.name);
        }
      } catch (error: any) {
        const errorMessage = error?.error?.message || error?.message || 'Error promoting asset.';
        this.addFailedPayload(errorMessage, buildJobRow.id, buildJobRow.name);
      }
    }
  }

  // Add a failed payload with a given error message
  private addFailedPayload(errorMessage: string, id?: any, name?: string) {
    this.bulkPromote.failedPayloads.push({ id, name, promotionError: errorMessage });
  }

  // Update the bulk promotion progress
  private updateProgress(current: number, total: number) {
    this.bulkPromoteProgress = Number(((current / total) * 100).toFixed(2));
  }

  // Show the results of the bulk promotion
  private showPromotionResults(isAssetPromotion: boolean) {
    const entityType = this.isCombinedPromotion ? 'assets & images' : (isAssetPromotion ? 'assets' : 'images');

    if (this.bulkPromote.successCount > 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'Promotion Successful',
        detail: `${this.bulkPromote.successCount} ${entityType} successfully promoted.`,
        life: 4000
      });
    }

    if (this.bulkPromote.failedPayloads && this.bulkPromote.failedPayloads.length > 0) {
      this.messageService.add({
        sticky: true,
        severity: 'error',
        summary: 'Promotion Error',
        detail: `${this.bulkPromote.failedPayloads.length} ${entityType} not promoted.`
      });
    }

    this.showBulkPromote = false;
    this.showBulkPromoteFailed = this.bulkPromote.failedPayloads && this.bulkPromote.failedPayloads.length > 0;
    this.disablePromoteButton = false;
    this.showPromoteProgress = false;
  }

  /**
   * Check safety gating logic.
   *
   * @param assetType Asset Type value
   * @param entity Entity data
   */
  validateAssetPromotion(entity: any) {
    let isValid = true;
    switch (this.entity) {
      case 'items':
        if
          (
          entity.itemStatus != 'Approved' ||
          entity.vendorStatus != 'Approved' ||
          entity.start == null ||
          entity.start == 0
        ) {
          isValid = false;
        }
        // Do not promote if "hold" flag is set
        if (entity.flagged && entity.flagged.toLowerCase() == 'hold') {
          isValid = false;
        }
        break;
    }

    return isValid;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  parseValue(value: string): string {
    try {
      const obj = JSON.parse(value);
      return obj.name + ' (' + obj.id + ')';
    } catch (e) {
      return value; // or handle the error as you see fit
    }
  }


  syncStoreV2AndPricePoints(env: 'dev' | 'test' | 'qa' | 'prod'): void {
    // Fire and forget style - not waiting for completion
    this.spinnerService.loadSpinner();
    
    // Brief delay to allow spinner to be visible, then trigger API calls
    setTimeout(() => {
      // Display notification to user
      this.messageService.add({
        severity: 'info',
        summary: 'Processing',
        detail: 'The sync process has been started. You will receive status updates in Slack when complete.',
        life: 5000
      });

      // Trigger store listings sync (fire and forget)
      this.httpClient.post(`/api/store/sync/store-listings-v2`, { env }).subscribe({
        next: () => {
          this.loggerService.info('Store listings sync request sent', { env }, 'AgTableActionsComponent');
          this.gridApi.refreshServerSide();
        },
        error: (error) => {
          this.loggerService.error('Error triggering store listings sync', error, 'AgTableActionsComponent');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Error starting Store Listings sync! Error: ${error.message}`
          });
        }
      });

      // Trigger price points sync (fire and forget)
      this.httpClient.post(`/api/store/sync/price-points`, { env }).subscribe({
        next: () => {
          this.loggerService.info('Price points sync request sent', { env }, 'AgTableActionsComponent');
          this.gridApi.refreshServerSide();
        },
        error: (error) => {
          this.loggerService.error('Error triggering price points sync', error, 'AgTableActionsComponent');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Error starting Price Points sync! Error: ${error.message}`
          });
        }
      });
      
      // End spinner after requests are sent (not waiting for completion)
      this.spinnerService.endSpinner();
    }, 500);
  }


  async addToCart(selected: any, individualID: number | null = null) {
    let rows: any[] = await this.getSelectedRows();
    // Map through each row to extract the id and assign it to result
    let result = rows.map((item: any) => item.id);
    this.agGridToolsService.addToCart(selected, result);
  }


  async viewDifferences(selected?: string) {
    var result = this.selectedRows.map((item: any) => {
      return item.id
    });

    this.differences = await firstValueFrom(this.httpClient.get<any>('/api/store/diffAll?entity=' + selected + '&ids=' + result.join()));


    this.differencesModal = true;
    this.differencesLoaded = true;
  }

  findFirstString(obj: any): string | undefined {
    if (typeof obj === 'string') {
      return obj
    } else {
      for (const key in obj) {
        if (typeof obj[key] === 'string') {
          return obj[key];
        }
        if (typeof obj[key] === 'object') {
          const result = this.findFirstString(obj[key]);
          if (result) {
            return result;
          }
        }
      }
      return undefined;
    }

  }

  navigateToDetails(id: any, entity: any) {
    window.open('/' + entity + '/' + id)
  }

  async bulkLocalize(collectionName: string): Promise<void> {
    const selectedRows = await this.getSelectedRows('id');
    var selectedIds = selectedRows.map((item: any) => {
      return item.id
    });
    const body = {
      ids: selectedIds,
      collection: collectionName
    };

    this.spinnerService.loadSpinner();

    try {
      const response = await firstValueFrom(this.httpClient.post<any>('/api/localization/worker/add', body));

      if (response.success) {
        // Show success toast
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sent Records for localization to AI.' });
      } else {
        // Show error toast
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to send Records for localization to AI.' });
      }
    } catch (error: any) {
      this.loggerService.error('Error sending Records for localization', error, 'AgTableActionsComponent');
      // Show error toast
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error);
      this.messageService.add({ severity: 'error', summary: 'Error sending Records for localization!', detail: errorMessage });
      throw error;
    } finally {
      this.spinnerService.endSpinner();
    }
  }

  async bulkTranslateGeneralStrings(): Promise<void> {
    // Use the grid's selection set (field keys / row ids), not a refetch from `/paginated`.
    // Refetching only applied sort + limit and ignored which rows were selected, so bulk
    // translate often received the wrong rows (e.g. a single "first" row by updatedAt).
    const fields = Array.from(this.selectedRowsSet ?? new Set()).filter(
      (id) => id !== undefined && id !== null && id !== '',
    );
    if (!fields.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No rows selected',
        detail: 'Select one or more records to translate.',
      });
      return;
    }
    const body = {
      fields,
      includeVerified: this.includeVerifiedClientStrings,
      onlyUntranslated: this.onlyUntranslatedClientStrings,
    };

    const bulkTranslateUrl = this.entity === 'localization/localized-strings'
      ? '/api/localization/localized-strings/bulk-translate'
      : '/api/localization/client-strings/bulk-translate';

    this.spinnerService.loadSpinner();

    try {
      const response = await firstValueFrom(
        this.httpClient.post<any>(bulkTranslateUrl, body)
      );

      if (response.success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Bulk Translation Queued',
          detail: `${response.queued} queued, ${response.skipped} skipped${response.skippedVerified ? ` (${response.skippedVerified} verified)` : ''}.`,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to queue bulk translation.',
        });
      }
    } catch (error: any) {
      this.loggerService.error('Error queuing bulk translation', error, 'AgTableActionsComponent');
      const errorMessage = error?.error?.message || error?.message || 'An unexpected error occurred';
      this.messageService.add({
        severity: 'error',
        summary: 'Error queuing bulk translation',
        detail: errorMessage,
      });
    } finally {
      this.spinnerService.endSpinner();
    }
  }

  async forceTranslateSelected(): Promise<void> {
    const selectedRows = await this.getSelectedRows('id');
    const verifiedRows = selectedRows.filter((item: any) => item.verified);

    if (!verifiedRows.length) {
      this.messageService.add({
        severity: 'info',
        summary: 'No verified records selected',
        detail: 'Select at least one verified record to force translate.',
      });
      return;
    }

    const forceTranslateUrl = this.entity === 'localization/localized-strings'
      ? '/api/localization/localized-strings/force-translate'
      : '/api/localization/client-strings/force-translate';

    this.spinnerService.loadSpinner();
    let queued = 0;
    const errors: string[] = [];

    for (const row of verifiedRows) {
      try {
        await firstValueFrom(this.httpClient.post<any>(forceTranslateUrl, { field: row.id }));
        queued++;
      } catch (err: any) {
        errors.push(row.id);
        this.loggerService.error(`Force translate failed for field=${row.id}`, err, 'AgTableActionsComponent');
      }
    }

    this.spinnerService.endSpinner();
    this.messageService.add({
      severity: errors.length ? 'warn' : 'success',
      summary: 'Force Translation',
      detail: `${queued} record(s) queued.${errors.length ? ` ${errors.length} failed: ${errors.join(', ')}` : ''}`,
    });
  }

  openFindReplaceDialog(): void {
    this.resetFindReplaceState();
    this.findReplaceDialogVisible = true;
  }

  closeFindReplaceDialog(): void {
    this.findReplaceDialogVisible = false;
  }

  backToFindReplaceForm(): void {
    this.findReplaceStep = 'form';
    this.findReplacePreviewRows = [];
    this.findReplaceTotalRecords = 0;
    this.findReplaceTriggerLocalization = false;
    this.findReplaceTruncated = false;
    this.findReplaceSkippedVerified = 0;
    this.findReplaceWillOverwrite = false;
    this.findReplaceExpectedIds = [];
  }

  async previewFindReplace(): Promise<void> {
    if (!this.canPreviewFindReplace) {
      return;
    }
    this.findReplaceLoading = true;
    this.spinnerService.loadSpinner();
    try {
      const response = await firstValueFrom(
        this.httpClient.post<any>('/api/localization/client-strings/find-replace/preview', this.buildFindReplacePayload()),
      );
      const matches = Array.isArray(response?.matches) ? response.matches : [];
      this.findReplacePreviewRows = matches.flatMap((match: any) =>
        (match.changes || []).map((change: any) => ({
          id: match.id,
          language: change.language,
          languageLabel: change.languageLabel,
          before: change.before,
          after: change.after,
          verified: !!match.verified,
        })),
      );
      this.findReplaceExpectedIds = matches.map((match: any) => match.id).filter((id: string) => !!id);
      this.findReplaceTotalRecords = response?.totalRecords ?? matches.length;
      this.findReplaceTruncated = !!response?.truncated;
      this.findReplaceSkippedVerified = response?.skippedVerified ?? 0;
      this.findReplaceWillOverwrite = !!response?.willOverwriteOtherLanguages;
      this.findReplaceTriggerLocalization = false;
      this.findReplaceStep = 'preview';
    } catch (error: any) {
      this.loggerService.error('Error previewing find & replace', error, 'AgTableActionsComponent');
      this.messageService.add({
        severity: 'error',
        summary: 'Find & Replace',
        detail: error?.error?.message || error?.message || 'Failed to preview matching records.',
      });
    } finally {
      this.findReplaceLoading = false;
      this.spinnerService.endSpinner();
    }
  }

  async applyFindReplace(): Promise<void> {
    if (!this.canApplyFindReplace) {
      return;
    }
    this.findReplaceLoading = true;
    this.spinnerService.loadSpinner();
    try {
      const response = await firstValueFrom(
        this.httpClient.post<any>('/api/localization/client-strings/find-replace', {
          ...this.buildFindReplacePayload(),
          expectedIds: this.findReplaceExpectedIds,
          triggerLocalization: this.isFindReplaceEnglishSelected && this.findReplaceTriggerLocalization,
        }),
      );
      const updated = response?.updated ?? 0;
      const localizationQueued = response?.localizationQueued ?? 0;
      const skippedVerified = response?.skippedVerified ?? 0;
      const details = [
        `Updated ${updated} record(s).`,
        localizationQueued ? `Localization job queued for ${localizationQueued} record(s).` : '',
        skippedVerified ? `${skippedVerified} verified record(s) skipped.` : '',
      ].filter(Boolean).join(' ');
      this.messageService.add({
        severity: 'success',
        summary: 'Find & Replace',
        detail: details,
      });
      this.tableCommunicationService.emitEvent('reloadDataSource');
      this.closeFindReplaceDialog();
    } catch (error: any) {
      this.loggerService.error('Error applying find & replace', error, 'AgTableActionsComponent');
      this.messageService.add({
        severity: 'error',
        summary: 'Find & Replace',
        detail: error?.error?.message || error?.message || 'Failed to apply find & replace.',
      });
    } finally {
      this.findReplaceLoading = false;
      this.spinnerService.endSpinner();
    }
  }

  private buildFindReplacePayload(): {
    find: string;
    replace: string;
    matchMode: 'exact' | 'partial';
    languages: string[];
    includeVerified: boolean;
  } {
    return {
      find: this.findReplaceFind,
      replace: this.findReplaceReplace,
      matchMode: this.findReplaceMatchMode,
      languages: this.findReplaceLanguages,
      includeVerified: this.findReplaceIncludeVerified,
    };
  }

  private resetFindReplaceState(): void {
    this.findReplaceStep = 'form';
    this.findReplaceFind = '';
    this.findReplaceReplace = '';
    this.findReplaceMatchMode = 'exact';
    this.findReplaceLanguages = ['Source_en'];
    this.findReplaceTriggerLocalization = false;
    this.findReplaceIncludeVerified = false;
    this.findReplaceLoading = false;
    this.findReplaceTotalRecords = 0;
    this.findReplaceTruncated = false;
    this.findReplaceSkippedVerified = 0;
    this.findReplaceWillOverwrite = false;
    this.findReplaceExpectedIds = [];
    this.findReplacePreviewRows = [];
  }

  async addToItemSet() {
    this.spinnerService.loadSpinner();
    const itemsToAdd = this.rowsSelected.map(rowNode => ({
        id: rowNode.data.id,
        _id: rowNode.data._id,
    }));

    const payload = {
        itemSetsId: this.selectedItemSet,
        sourcingItems: itemsToAdd,
        existingItem: false
    };

    this.loggerService.debug('addToItemSet payload', payload, 'AgTableActionsComponent');

    try {
        let result = await this.itemSetService.addToItemSet(payload);
        this.loggerService.debug('addToItemSet result', result, 'AgTableActionsComponent');

        if (result && result.success) {
            this.addToItemSetDialogVisible = true;
            this.messageService.add({
                sticky: true,
                severity: 'success',
                summary: 'Success',
                detail: 'Uploaded Items were successfully uploaded to collection.',
            });
        } else {
            this.messageService.add({
                sticky: true,
                severity: 'error',
                summary: 'Error',
                detail: 'No Collection Selected or API Error.',
            });
        }
    } catch (error: any) {
        this.loggerService.error('Error in addToItemSet', error, 'AgTableActionsComponent');
        const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error);
        this.showMessage('error', 'API Error', errorMessage);
    }

    this.spinnerService.endSpinner();
    this.addToItemSetDialogVisible = false;
}


  async createAndAddToItemSet() {
    try {
      this.spinnerService.loadSpinner();
      const itemsToAdd = this.rowsSelected.map(rowNode => ({
        id: rowNode.data.id,
        _id: rowNode.data._id,
      }));
      this.createItemSet.items_ref = itemsToAdd;

      let result = await this.itemSetService.createItemSet({ data: this.createItemSet });

      if (result) {
        if (result.success) {
          this.createItemSetDialogVisible = false;
          this.messageService.add({
            sticky: true,
            severity: 'success',
            summary: 'Success',
            detail: 'Successfully created an item set and added the items.',
          });
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'error',
            summary: 'Error',
            detail: 'No Item Set Created.',
          });
        }
      } else {
        this.messageService.add({
          sticky: true,
          severity: 'error',
          summary: 'API Error',
          detail: 'There is an error in the API request.',
        });
      }
    } catch (error: any) {
      const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : JSON.stringify(error.error || error);
      this.showMessage('error', 'Conflict Error', errorMessage);
      this.loggerService.error('Error creating item set', error, 'AgTableActionsComponent');
    } finally {
      this.spinnerService.endSpinner();
      this.createItemSetDialogVisible = false;
      this.addToItemSetDialogVisible = false;

    }
  }

  showRenderDiffDialog(){
    this.display = false;
    this.displayRenderDiffDialog = true;
  }

  toggleDuplicate(){
    this.tableCommunicationService.duplicateRow({
      id: this.rowsSelected.map((rowNode: any) => rowNode.data.id),
      _id: this.rowsSelected.map((rowNode: any) => rowNode.data._id),
      isBulk: true,
      qty: this.rowsSelected.length,
      entity: this.entity,
      sourceTableId: this.tableInstanceId,
    });
  }

  // Add to class properties
  successfulEdits: string[] = [];
  failedEdits: { id: string, error: string }[] = [];
  showSuccessDialog: boolean = false;

  // Add method to close success dialog
  closeSuccessDialog() {
    this.showSuccessDialog = false;
    this.successfulEdits = [];
    this.failedEdits = [];
    this.bulkEditState = 'select-column';
    this.bulkEditStep = 0;
    this.selectedBulkEditColumns = [];
    this.editType = null;

    this.tableCommunicationService.emitEvent('reloadDataSource');
  }

  isSyncingChallengeTags: boolean = false;

  public async challengeTagsClicked() {
    this.isSyncingChallengeTags = true;
    try {
      const response: any = await this.httpClient.post('/api/challenges/challenge-tags/sync-with-ai-server', {}).toPromise();
      this.loggerService.debug('[SYNC-AI] Full backend response', response, 'AgTableActionsComponent');
      if (response.message && response.message.includes('configured successfully')) {
        this.messageService.add({
          severity: 'success',
          summary: 'Challenge Tags Synced',
          detail: response.message,
          life: 8000
        });
        this.loggerService.info('[SYNC-AI] Challenge tags successfully synced with AI server', null, 'AgTableActionsComponent');
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Sync Failed',
          detail: response.message || 'Failed to sync challenge tags',
        });
        this.loggerService.error('[SYNC-AI] Challenge tags sync failed', response, 'AgTableActionsComponent');
      }
    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        summary: 'Sync Failed',
        detail: error?.error?.message || error?.message || 'Failed to sync challenge tags',
      });
      this.loggerService.error('[SYNC-AI] Error syncing challenge tags', error, 'AgTableActionsComponent');
    } finally {
      this.isSyncingChallengeTags = false;
    }
  }

  showAiTagChallengesDialog: boolean = false;
  isSyncingAiTagChallenges: boolean = false;
  aiTagChallengesResult: any = null;

  openAiTagChallengesDialog() {
    this.showAiTagChallengesDialog = true;
    this.aiTagChallengesResult = null;
  }

  closeAiTagChallengesDialog() {
    this.showAiTagChallengesDialog = false;
    this.isSyncingAiTagChallenges = false;
    this.aiTagChallengesResult = null;
  }

  async aiTagSelectedChallenges() {
    this.isSyncingAiTagChallenges = true;
    this.aiTagChallengesResult = null;
    try {
      const selectedRows = await this.getSelectedRows('id');
      const challenge_ids = selectedRows.map((item: any) => item.id);
      const payload = { challenge_ids };
      const response: any = await this.httpClient.post('/api/challenges/ai-tag-challenges', payload).toPromise();
      this.aiTagChallengesResult = response;
      this.messageService.add({
        severity: 'success',
        summary: 'AI Tagging Completed',
        detail: 'AI tagging completed successfully.',
        life: 6000
      });
    } catch (error: any) {
      this.aiTagChallengesResult = error?.error || error;
      this.messageService.add({
        severity: 'error',
        summary: 'AI Tagging Failed',
        detail: error?.error?.message || error?.message || 'Failed to tag challenges with AI',
        life: 6000
      });
    } finally {
      this.isSyncingAiTagChallenges = false;
    }
  }

  // --- Range Tagging State ---
  showRangeTagDialog: boolean = false;
  showRangeTagResultDialog: boolean = false;
  rangeStartId: number | null = null;
  rangeEndId: number | null = null;
  rangeTagResult: any = null;
  rangeTagError: string = '';
  isSyncingRangeTag: boolean = false;

  openRangeTagDialog() {
    this.showRangeTagDialog = true;
    this.rangeStartId = null;
    this.rangeEndId = null;
    this.rangeTagError = '';
  }

  tagRangeOfChallenges() {
    if (!this.rangeStartId || !this.rangeEndId) {
      this.rangeTagError = 'Both Start ID and End ID are required.';
      return;
    }
    if (this.rangeStartId > this.rangeEndId) {
      this.rangeTagError = 'Start ID must be less than or equal to End ID.';
      return;
    }
    this.isSyncingRangeTag = true;
    this.rangeTagError = '';
    const payload = { start_id: this.rangeStartId, end_id: this.rangeEndId };
    this.httpClient.post('/api/challenges/ai-tag-challenges', payload).toPromise()
      .then((result) => {
        this.rangeTagResult = result;
        this.showRangeTagResultDialog = true;
        this.showRangeTagDialog = false;
      })
      .catch((err) => {
        this.rangeTagResult = err?.error || err;
        this.showRangeTagResultDialog = true;
        this.showRangeTagDialog = false;
      })
      .finally(() => {
        this.isSyncingRangeTag = false;
      });
  }
}
